import * as milestones from '../mocks/mockMilestoneEvents';
import { ArticleEvent, Milestone } from '../models/shipments';

const STANDARD_MILESTONES_WITH_NEXT: string[] = [
  Milestone.LABEL_CREATED_BY_SENDER,
  Milestone.WEVE_GOT_IT,
  Milestone.ON_ITS_WAY,
  Milestone.COMING_TODAY,
];

const isAddressToCollectionPoint = (addressType?: string | null) => {
  const collectionPoints = ['PL', 'PC', 'PO'];
  if (addressType && collectionPoints.includes(addressType)) return true;
  return false;
};
const milestoneJourney = (addressType?: string | null) => [
  ...STANDARD_MILESTONES_WITH_NEXT,
  isAddressToCollectionPoint(addressType) ? Milestone.AWAITING_COLLECTION : Milestone.DELIVERED,
];

export const getFutureMilestones = (milestone: string, addressType?: string | null): string[] => {
  if (milestone === Milestone.ATTEMPTED_DELIVERY) return [Milestone.AWAITING_COLLECTION];
  const currentMilestoneIndex = milestoneJourney(addressType).indexOf(milestone);
  if (currentMilestoneIndex === -1) return [];
  return milestoneJourney(addressType).slice(currentMilestoneIndex + 1);
};

export const showEdd = (milestone: string) => STANDARD_MILESTONES_WITH_NEXT.includes(milestone);

export const getMilestoneEvents = (milestone: string) => {
  let event: ArticleEvent[];
  switch (milestone) {
    case Milestone.LABEL_CREATED_BY_SENDER:
      event = milestones.labelCreatedBySender;
      break;
    case Milestone.WEVE_GOT_IT:
      event = milestones.weveGotIt;
      break;
    case Milestone.ON_ITS_WAY:
      event = milestones.itsOnItsWay;
      break;
    case Milestone.COMING_TODAY:
      event = milestones.itsComingToday;
      break;
    case Milestone.DELIVERED:
      event = milestones.delivered;
      break;
    case Milestone.AWAITING_COLLECTION:
      event = milestones.awaitingCollection;
      break;
    case Milestone.ATTEMPTED_DELIVERY:
      event = milestones.attemptedDelivery;
      break;
    case Milestone.CONTACT_SENDER:
      event = milestones.contactSender;
      break;
    default:
      event = [];
      break;
  }
  return event;
};
